import { render, staticRenderFns } from "./FormAction.vue?vue&type=template&id=6d461422&"
import script from "./FormAction.vue?vue&type=script&lang=ts&"
export * from "./FormAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports